import { resolveApiBaseUrl } from '../utils/apiBaseUrl';
import * as tokenStorage from '../utils/tokenStorage';
import { createActivityPinger } from '../utils/activityPing';

/**
 * Network side of the activity ping (see utils/activityPing.ts).
 *
 * Uses plain fetch instead of apiService on purpose: the ping must never go
 * through the axios interceptors, so a failed or 401 ping cannot trigger a
 * token refresh, a sign-out, or any other pane effect.
 */
function post(path: string, token?: string | null): void {
  if (typeof fetch !== 'function') return;
  try {
    void fetch(`${resolveApiBaseUrl()}${path}`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    /* best-effort */
  }
}

function readToken(): string | null {
  try {
    return tokenStorage.getToken();
  } catch {
    return null; // localStorage unavailable
  }
}

const pinger = createActivityPinger({
  send: () => {
    const token = readToken();
    if (!token) return;
    post('/activity/ping', token);
  },
});

/** Call on real pane input only. Throttled; safe to call very often. */
export function notifyUserActivityPing(): void {
  pinger.notify();
}

/** Call on sign-out so the next session pings on its first interaction. */
export function resetActivityPing(): void {
  pinger.reset();
}

let paneWarmupSent = false;

/**
 * Unauthenticated warmup sent when the pane loads: wakes backend, engine and
 * ClamAV while the user is still signing in. Sent once per pane load.
 */
export function sendPaneWarmup(): void {
  if (paneWarmupSent) return;
  paneWarmupSent = true;
  post('/activity/warmup');
}
